import { ProductOperationDetailResponse } from '@repo/accounts-types'
import { GenericOperationState } from '@repo/core'
import { RootState } from '../../../../store/types'

export const productOperationDetailSelectorConfig = {
  productOperationDetailSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ProductOperationDetailResponse | null> {
      return state.accounts.detail.read.fund.operationDetail
    },
  },
}
